import {
  ADMIN_DELETE_USER_START,
  ADMIN_DELETE_USER_SUCCESS,
  ADMIN_DELETE_USER_ERROR
} from '../../constants';

import history from '../../core/history';
import showToaster from '../../helpers/showToaster';
import { deleteUser as mutation } from '../../lib/graphql';

export function deleteUser(userId) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: ADMIN_DELETE_USER_START,
      data: userId
    });
    let isAdmin = getState()?.runtime?.isAdminAuthenticated;

    try {
      dispatch({
        type: ADMIN_DELETE_USER_START,
        data: userId
      });

      const { data } = await client.mutate({
        mutation,
        variables: { userId, userType: "admin" },
      });

      if (data?.deleteUser?.status == 200) {
        dispatch({
          type: ADMIN_DELETE_USER_SUCCESS,
        });
        isAdmin ? showToaster({ messageId: 'deleteUser', toasterType: 'success' }) : showToaster({ messageId: 'deleteUserAccount', toasterType: 'success' })

        isAdmin ? history.push('/siteadmin/users') : history.push('/');

      } else {
        dispatch({
          type: ADMIN_DELETE_USER_ERROR,
        });
        showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.deleteUser?.errorMessage })
      }
    } catch (error) {
      dispatch({
        type: ADMIN_DELETE_USER_ERROR,
        payload: {
          error
        }
      });
    }
  };
}
